const handleFilterChange = (
  updateType: "replace" | "remove",
  values: {},
  filters,
  updateFilters
) => {
  switch (updateType) {
    case "replace":
      updateFilters({ ...filters, page: 1, ...values });
      break;
    case "remove":
      const props = Object.entries(values).map((e) => ({
        [e[0]]: filters[e[0]].filter((x) => x !== e[1])
      }));
      updateFilters({
        ...filters,
        page: 1,
        ...props[0]
      });
      break;
  }
};

export default handleFilterChange;
